import { Flex } from '@mantine/core';
import type { AutomationMetrics } from '@repo/api-codegen';
import { memo } from 'react';
import { BoltIcon, CircleCheckFilledIcon } from '../icons';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MetricsAutomationCardsProps {
	automationMetrics: AutomationMetrics;
}

export const MetricsAutomationCards = memo(
	({ automationMetrics }: MetricsAutomationCardsProps) => (
		<Flex py="lg" w="100%" justify="space-between" align="center" gap="md">
			<MetricsOverviewCard
				noPointer
				title="Automation runs"
				value={automationMetrics?.total_automations ?? 0}
				icon={CircleCheckFilledIcon}
			/>
			<MetricsOverviewCard
				noPointer
				title="Tasks automated"
				value={automationMetrics?.total_tasks_automated ?? 0}
				icon={BoltIcon}
			/>
		</Flex>
	)
);

MetricsAutomationCards.displayName = 'MetricsAutomationCards';
